export default "__VITE_ASSET__DxYRUePa__"